import React from 'react';

const Footer: React.FC = () => {
    return (
        <div className="col-sm-3 footer">
            <footer className="pd-footer">
                <div className="pd-primary background" id="footerBanner">
                    <p>&copy; 2025 Paradigm Math LLC</p>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
